export interface ConfirmRedirectState {
  userConfirmedRedirect: boolean | undefined;
  shouldDisplayPrompt: boolean | undefined;
}

export const initialConfirmRedirectState: ConfirmRedirectState = {
  userConfirmedRedirect: true,
  shouldDisplayPrompt: true,
}